import { module, isDefined, ILogService } from 'angular';

function replace($log: ILogService): Function {
  return (str: string, regExStr: string, replaceValue: string) => {
    if (!isDefined(regExStr)) {
      $log.debug(`Did not supply regex string for 'replace' filter.`);
      return str;
    } else if (!isDefined(replaceValue)) {
      $log.debug(`Did not supply replacement value for 'replace' filter.`);
      return str;
    } else {
      return str.replace(new RegExp(regExStr, 'g'), replaceValue);
    }
  };
}

export const REPLACE_FILTER = 'spinnaker.core.replace.filter';
module(REPLACE_FILTER, []).filter('replace', replace);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/presentation/replace.filter.ts